/*
 * @Author: co
 * @Date: 2021-09-27 16:05:32
 */
import BasicLayout from '@/layouts/basic-layout'
const prefix = 'report-center-unexpired-lease-contract-statement-month-'
export default {
  path: '/report-center/unexpired-lease-contract-statement-month',
  redirect: { name: `${prefix}index` },
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: { cache: true, title: '未到期有效出租合同(定时生成)' },
      component: () => import('@/pages/report-center/unexpired-lease-contract-statement-month/index')
    },
  ]
}
